var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33301L18.75 5.20801L12.5 2.08301V12.4997",
    stroke: "#EAA245",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 12.4893L2.60424 15.7601C2.44393 15.8509 2.31059 15.9827 2.21782 16.1419C2.12505 16.3011 2.07617 16.4821 2.07617 16.6663C2.07617 16.8506 2.12505 17.0316 2.21782 17.1908C2.31059 17.35 2.44393 17.4817 2.60424 17.5726L11.4584 22.6351C11.7751 22.8179 12.1344 22.9142 12.5001 22.9142C12.8658 22.9142 13.225 22.8179 13.5417 22.6351L22.3959 17.5726C22.5562 17.4817 22.6896 17.35 22.7823 17.1908C22.8751 17.0316 22.924 16.8506 22.924 16.6663C22.924 16.4821 22.8751 16.3011 22.7823 16.1419C22.6896 15.9827 22.5562 15.8509 22.3959 15.7601L16.6667 12.4997",
    stroke: "#EAA245",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76074 13.3857L18.2399 19.9482",
    stroke: "#EAA245",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2393 13.3857L6.77051 19.9482",
    stroke: "#EAA245",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandIcon);
export default __webpack_public_path__ + "static/media/LandIcon.87c197977eab0a706b4e6c198862cf67.svg";
export { ForwardRef as ReactComponent };